import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createSlots as _createSlots, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Chọn khách hàng")
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khách hàng", -1)
const _hoisted_7 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-6 p-lg-4"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Tiền nợ")
const _hoisted_9 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-6 p-lg-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "Số tiền còn nợ", -1)
const _hoisted_12 = { class: "p-field p-col p-col-6 p-md-6 p-lg-6" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Chi tiết", -1)
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Dịch vụ")
const _hoisted_17 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_18 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "Chọn dịch vụ", -1)
const _hoisted_20 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_22 = {
  key: 0,
  class: "p-field p-col p-col-6 p-md-6 p-lg-6"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_24 = {
  key: 1,
  class: "p-field p-col p-col-6 p-md-6 p-lg-6"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1)
const _hoisted_26 = { style: {"color":"red"} }
const _hoisted_27 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Liệu trình")
const _hoisted_29 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_30 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", null, "Chọn liệu trình", -1)
const _hoisted_32 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_34 = {
  key: 0,
  class: "p-field p-col p-col-6 p-md-6 p-lg-6"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_36 = {
  key: 1,
  class: "p-field p-col p-col-6 p-md-6 p-lg-6"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1)
const _hoisted_38 = { style: {"color":"red"} }
const _hoisted_39 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Sản phẩm")
const _hoisted_41 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_42 = { class: "p-field p-col p-col-12 p-md-8 p-lg-8" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", null, "Chọn sản phẩm", -1)
const _hoisted_44 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", null, "Giá thực thu", -1)
const _hoisted_46 = {
  key: 0,
  class: "p-field p-col p-col-6 p-md-6 p-lg-6"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", null, "Số lượng", -1)
const _hoisted_48 = {
  key: 1,
  class: "p-field p-col p-col-6 p-md-6 p-lg-6"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1)
const _hoisted_50 = { style: {"color":"red"} }
const _hoisted_51 = { class: "p-fluid" }
const _hoisted_52 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_53 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_54 = {
  class: "p-input-icon-left",
  style: {"width":"18em"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_56 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-12 p-lg-12"
}
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Thanh toán")
const _hoisted_58 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_59 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền", -1)
const _hoisted_61 = { class: "p-field p-col p-col-6 p-md-4 p-lg-3" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá theo %", -1)
const _hoisted_63 = { class: "p-field p-col p-col-6 p-md-4 p-lg-3" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", null, "Giảm tiền", -1)
const _hoisted_65 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", null, "Tổng thực thu", -1)
const _hoisted_67 = { class: "flex gap-3 mt-1" }
const _hoisted_68 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_69 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_70 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", null, "Tổng thực thu", -1)
const _hoisted_72 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", null, "Trả trước", -1)
const _hoisted_74 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", null, "Còn lại", -1)
const _hoisted_76 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_77 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê: ", -1)
const _hoisted_79 = {
  key: 0,
  class: "p-field p-col p-col-12 p-md-4 p-lg-2"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", null, "Hiển thị doanh thu:", -1)
const _hoisted_81 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_82 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_83 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_84 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", null, "Tổng doanh thu", -1)
const _hoisted_86 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", null, "Tổng chi phí", -1)
const _hoisted_88 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", null, "Tổng lợi nhuận", -1)
const _hoisted_90 = {
  class: "p-field p-col p-col-12 p-md-4 p-lg-3",
  style: {"color":"red"}
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền nợ", -1)
const _hoisted_92 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_93 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_94 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_95 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_96 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_97 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_98 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_99 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_100 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_101 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_102 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_103 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền", -1)
const _hoisted_105 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", null, "Giảm giá(%)", -1)
const _hoisted_107 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", null, "Tổng thực thu", -1)
const _hoisted_109 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", null, "Số tiền đã thu", -1)
const _hoisted_111 = { class: "p-field p-col p-col-6 p-md-4 p-lg-4" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", null, "Số tiền nợ", -1)
const _hoisted_113 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_114 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thống kê: ", -1)
const _hoisted_116 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_117 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_118 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_119 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("label", null, "Tổng doanh thu", -1)
const _hoisted_121 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("label", null, "Tổng chi phí", -1)
const _hoisted_123 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("label", null, "Tổng lợi nhuận", -1)
const _hoisted_125 = {
  class: "p-field p-col p-col-12 p-md-4 p-lg-3",
  style: {"color":"red"}
}
const _hoisted_126 = /*#__PURE__*/_createElementVNode("label", null, "Tổng tiền nợ", -1)
const _hoisted_127 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_128 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_129 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", null, "Tên liệu trình", -1)
const _hoisted_131 = { class: "p-field p-col p-col-12 p-md-4 p-lg-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", null, "Số lần thực hiện", -1)
const _hoisted_133 = { class: "p-field p-col p-col-12 p-md-4 p-llg-3" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", null, "Chọn khoản thời gian thực hiện: ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Card = _resolveComponent("Card")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Chọn khách hàng" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Card, null, {
              title: _withCtx(() => [
                _hoisted_3
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_Dropdown, {
                      id: "khachHang",
                      filter: true,
                      showClear: true,
                      modelValue: $setup.khachHang.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.khachHang.id) = $event)),
                      options: $setup.listKhachHang,
                      optionLabel: "tenKhachHang",
                      optionValue: "id",
                      placeholder: "Vui lòng chọn khách hàng ...",
                      onChange: $setup.changeKhachHang
                    }, null, 8, ["modelValue", "options", "onChange"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          ($setup.debt.tienNo > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_Card, null, {
                  title: _withCtx(() => [
                    _hoisted_8
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createVNode(_component_InputText, {
                          id: "tienConNo",
                          type: "text",
                          value: $setup.formatCurrency($setup.debt.tienNo),
                          readonly: ""
                        }, null, 8, ["value"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createVNode(_component_Button, {
                          label: "Xem chi tiết",
                          class: "btn-spa-add",
                          icon: "pi pi-cart-plus",
                          iconPos: "left",
                          onClick: $setup.clickShowTienNo
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    ($setup.khachHang.id > 0)
      ? (_openBlock(), _createBlock(_component_Accordion, {
          key: 0,
          activeIndex: 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AccordionTab, {
              header: "MUA HÀNG",
              style: {"font-weight":"bold"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Panel, { header: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_Card, null, _createSlots({
                          title: _withCtx(() => [
                            _hoisted_16
                          ]),
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _createVNode(_component_Dropdown, {
                                  id: "dichVu",
                                  filter: true,
                                  showClear: true,
                                  modelValue: $setup.dichVu.id,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.dichVu.id) = $event)),
                                  options: $setup.listDichVu,
                                  optionLabel: "tenDichVu",
                                  optionValue: "id",
                                  placeholder: "Vui lòng chọn dịch vụ ...",
                                  onChange: $setup.changeDichVu
                                }, null, 8, ["modelValue", "options", "onChange"])
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _createVNode(_component_InputNumber, {
                                  id: "giaBan1",
                                  type: "text",
                                  modelValue: $setup.dichVu.giaThucThu,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.dichVu.giaThucThu) = $event)),
                                  inputId: "integeronly"
                                }, null, 8, ["modelValue"])
                              ]),
                              ($setup.dichVu.id > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createVNode(_component_InputText, {
                                      id: "soLuong1",
                                      type: "text",
                                      modelValue: $setup.soLuongDV,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.soLuongDV) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.dichVu.id > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _hoisted_25,
                                    ($setup.soLuongDV > 0)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          label: "Thêm vào giỏ",
                                          class: "btn-spa-add",
                                          icon: "pi pi-cart-plus",
                                          iconPos: "left",
                                          onClick: $setup.addDichVu
                                        }, null, 8, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_Button, {
                                          key: 1,
                                          label: "Thêm vào giỏ",
                                          class: "btn-spa-add",
                                          icon: "pi pi-cart-plus",
                                          iconPos: "left",
                                          disabled: "disabled"
                                        }))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, [
                          ($setup.dichVu.id > 0)
                            ? {
                                name: "footer",
                                fn: _withCtx(() => [
                                  _createElementVNode("label", _hoisted_26, "Thành tiền: " + _toDisplayString($setup.formatCurrency($setup.soLuongDV*$setup.dichVu.giaThucThu)), 1)
                                ])
                              }
                            : undefined
                        ]), 1024)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Card, null, _createSlots({
                          title: _withCtx(() => [
                            _hoisted_28
                          ]),
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createVNode(_component_Dropdown, {
                                  id: "lieuTrinh",
                                  filter: true,
                                  showClear: true,
                                  modelValue: $setup.lieuTrinh.id,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.lieuTrinh.id) = $event)),
                                  options: $setup.listLieuTrinh,
                                  optionLabel: "tenLieuTrinh",
                                  optionValue: "id",
                                  placeholder: "Vui lòng chọn liệu trình ...",
                                  onChange: $setup.changeLieuTrinh
                                }, null, 8, ["modelValue", "options", "onChange"])
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createVNode(_component_InputNumber, {
                                  id: "giaBan",
                                  type: "text",
                                  modelValue: $setup.lieuTrinh.giaThucThu,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.lieuTrinh.giaThucThu) = $event)),
                                  inputId: "integeronly"
                                }, null, 8, ["modelValue"])
                              ]),
                              ($setup.lieuTrinh.id > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createVNode(_component_InputText, {
                                      id: "soLuong",
                                      type: "text",
                                      modelValue: $setup.soLuongLT,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.soLuongLT) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.lieuTrinh.id > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _hoisted_37,
                                    ($setup.soLuongLT > 0)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          label: "Thêm vào giỏ",
                                          icon: "pi pi-cart-plus",
                                          iconPos: "left",
                                          class: "btn-spa-add",
                                          onClick: $setup.addLieuTrinh
                                        }, null, 8, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_Button, {
                                          key: 1,
                                          label: "Thêm vào giỏ",
                                          icon: "pi pi-cart-plus",
                                          iconPos: "left",
                                          class: "btn-spa-add",
                                          disabled: "disabled"
                                        }))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, [
                          ($setup.lieuTrinh.id > 0)
                            ? {
                                name: "footer",
                                fn: _withCtx(() => [
                                  _createElementVNode("label", _hoisted_38, "Thành tiền: " + _toDisplayString($setup.formatCurrency($setup.soLuongLT*$setup.lieuTrinh.giaThucThu)), 1)
                                ])
                              }
                            : undefined
                        ]), 1024)
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _createVNode(_component_Card, null, _createSlots({
                          title: _withCtx(() => [
                            _hoisted_40
                          ]),
                          content: _withCtx(() => [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode(_component_Dropdown, {
                                  id: "sanPham",
                                  filter: true,
                                  showClear: true,
                                  modelValue: $setup.sanPham.id,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.sanPham.id) = $event)),
                                  options: $setup.listSanPham,
                                  optionLabel: "tenSanPham",
                                  optionValue: "id",
                                  placeholder: "Vui lòng chọn sản phẩm ...",
                                  onChange: $setup.changeSanPham
                                }, null, 8, ["modelValue", "options", "onChange"])
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createVNode(_component_InputNumber, {
                                  id: "giaBan",
                                  type: "text",
                                  modelValue: $setup.sanPham.giaThucThu,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.sanPham.giaThucThu) = $event)),
                                  inputId: "integeronly"
                                }, null, 8, ["modelValue"])
                              ]),
                              ($setup.sanPham.id > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createVNode(_component_InputText, {
                                      id: "soLuong",
                                      type: "text",
                                      modelValue: $setup.soLuongSP,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.soLuongSP) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.sanPham.id > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _hoisted_49,
                                    ($setup.soLuongSP > 0)
                                      ? (_openBlock(), _createBlock(_component_Button, {
                                          key: 0,
                                          label: "Thêm vào giỏ",
                                          icon: "pi pi-cart-plus",
                                          iconPos: "left",
                                          class: "btn-spa-add",
                                          onClick: $setup.addSanPham
                                        }, null, 8, ["onClick"]))
                                      : (_openBlock(), _createBlock(_component_Button, {
                                          key: 1,
                                          label: "Thêm vào giỏ",
                                          icon: "pi pi-cart-plus",
                                          iconPos: "left",
                                          class: "btn-spa-add",
                                          disabled: "disabled"
                                        }))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, [
                          ($setup.sanPham.id > 0)
                            ? {
                                name: "footer",
                                fn: _withCtx(() => [
                                  _createElementVNode("label", _hoisted_50, "Thành tiền: " + _toDisplayString($setup.formatCurrency($setup.soLuongSP*$setup.sanPham.giaThucThu)), 1)
                                ])
                              }
                            : undefined
                        ]), 1024)
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Panel, { header: "Danh sách chọn" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_DataTable, {
                          value: $setup.listThanhPhan,
                          showGridlines: true,
                          paginator: true,
                          stripedRows: "",
                          rows: 10,
                          rowsPerPageOptions: [10,25,50],
                          rowHover: true,
                          filters: $setup.filters,
                          "onUpdate:filters": _cache[12] || (_cache[12] = ($event: any) => (($setup.filters) = $event)),
                          dataKey: "id",
                          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                          globalFilterFields: ['tenThanhPhan','maThanhPhan'],
                          currentPageReportTemplate: "Có tổng số {totalRecords} sản phẩm được chọn",
                          columnResizeMode: "fit"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_53, [
                              _createVNode(_component_Button, {
                                type: "button",
                                icon: "pi pi-filter-slash",
                                label: "Xoá",
                                class: "p-button-outlined",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.clearFilter())),
                                style: {"width":"100px","margin-right":"10px"}
                              }),
                              _createElementVNode("span", _hoisted_54, [
                                _hoisted_55,
                                _createVNode(_component_InputText, {
                                  modelValue: $setup.filters['global'].value,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.filters['global'].value) = $event)),
                                  placeholder: "Tìm theo tên sản phẩm, loại"
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              header: "Stt",
                              headerStyle: "width:3rem"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tenThanhPhan",
                              header: "Tên sản phẩm",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "loaiThanhPhan",
                              header: "Loại",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "giaBan",
                              header: "Giá bán",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "giamGia",
                              header: "Giảm giá (%)",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "giaThucThu",
                              header: "Giá hiện tại",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "soLuong",
                              header: "Số lượng",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "tongTien",
                              header: "Thành tiền",
                              style: {"font-weight":"bold","color":"red"},
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.tongTien)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                              body: _withCtx(({ data }) => [
                                _createVNode(_component_Button, {
                                  style: {"width":"150px"},
                                  class: "btn-spa-pause",
                                  type: "button",
                                  label: "Xóa",
                                  icon: "pi pi-trash",
                                  onClick: ($event: any) => ($setup.confirmDelete($event, data))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ColumnGroup, { type: "footer" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Column, {
                                      footer: "Tổng tiền:",
                                      colspan: 7,
                                      footerStyle: "text-align:right"
                                    }),
                                    _createVNode(_component_Column, {
                                      footer: $setup.tongTienFormatted,
                                      style: {"font-weight":"bold","color":"#3173b0"}
                                    }, null, 8, ["footer"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "filters"])
                      ]),
                      ($setup.tongTien)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                            _createVNode(_component_Card, null, {
                              title: _withCtx(() => [
                                _hoisted_57
                              ]),
                              content: _withCtx(() => [
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _hoisted_60,
                                    _createVNode(_component_InputNumber, {
                                      id: "tongTien",
                                      type: "text",
                                      modelValue: $setup.tongTien,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.tongTien) = $event)),
                                      inputId: "integeronly",
                                      readonly: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createVNode(_component_InputNumber, {
                                      id: "giaBan",
                                      type: "text",
                                      modelValue: $setup.giamPhanTram,
                                      "onUpdate:modelValue": [
                                        _cache[14] || (_cache[14] = ($event: any) => (($setup.giamPhanTram) = $event)),
                                        $setup.tinhTien
                                      ],
                                      inputId: "integeronly"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_63, [
                                    _hoisted_64,
                                    _createVNode(_component_InputNumber, {
                                      id: "giaBan",
                                      type: "text",
                                      modelValue: $setup.giamGia,
                                      "onUpdate:modelValue": [
                                        _cache[15] || (_cache[15] = ($event: any) => (($setup.giamGia) = $event)),
                                        $setup.tinhTien
                                      ],
                                      inputId: "integeronly"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _hoisted_66,
                                    _createVNode(_component_InputNumber, {
                                      id: "tongTienThucThu",
                                      type: "text",
                                      modelValue: $setup.tongThucThu,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.tongThucThu) = $event)),
                                      inputId: "integeronly",
                                      readonly: "",
                                      style: {"color":"red","font-weight":"bold"}
                                    }, null, 8, ["modelValue"])
                                  ])
                                ])
                              ]),
                              footer: _withCtx(() => [
                                _createElementVNode("div", _hoisted_67, [
                                  _createVNode(_component_Button, {
                                    label: "Xử lý",
                                    class: "btn-spa-buy",
                                    icon: "pi pi-receipt",
                                    style: {"width":"150px"},
                                    onClick: $setup.clickXuLy
                                  }, null, 8, ["onClick"])
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_68, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.confirmTransaction,
                    "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => (($setup.confirmTransaction) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '70vw'},
                    breakpoints: { '1500px': '50vw', '1150px': '60vw', '800px': '90vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Xác nhận thanh toán" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _createVNode(_component_InputNumber, {
                                id: "tongTienThucThu",
                                type: "text",
                                modelValue: $setup.tongThucThu,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.tongThucThu) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createVNode(_component_InputNumber, {
                                id: "soTienTraTruoc",
                                type: "text",
                                modelValue: $setup.traTruoc,
                                "onUpdate:modelValue": [
                                  _cache[18] || (_cache[18] = ($event: any) => (($setup.traTruoc) = $event)),
                                  $setup.clickTraTruoc
                                ],
                                inputId: "integeronly",
                                style: {"color":"red","font-weight":"bold"}
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode(_component_InputNumber, {
                                id: "soTienConLai",
                                type: "text",
                                modelValue: $setup.conLai,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.conLai) = $event)),
                                inputId: "integeronly",
                                style: {"color":"red","font-weight":"bold"}
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createVNode(_component_Button, {
                            label: "Thanh toán",
                            icon: "pi pi-money-bill",
                            iconPos: "left",
                            class: "btn-spa-buy",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.createMuaDichVu()))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_AccordionTab, {
              header: "LỊCH SỬ MUA HÀNG",
              style: {"font-weight":"bold"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Panel, { header: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode(_component_Calendar, {
                          id: "date",
                          modelValue: $setup.date,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (($setup.date) = $event)),
                          selectionMode: "range",
                          dateFormat: "dd/mm/yy",
                          showButtonBar: true,
                          showIcon: true,
                          manualInput: false,
                          monthNavigator: true,
                          yearNavigator: true,
                          yearRange: "2000:2100",
                          onDateSelect: _cache[23] || (_cache[23] = ($event: any) => ($setup.selectCalendar())),
                          onClearClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.clearCalendar()))
                        }, null, 8, ["modelValue"])
                      ]),
                      ($setup.listHoaDon.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _hoisted_80,
                            _createVNode(_component_Button, {
                              label: "Xem",
                              class: "btn-spa-add",
                              icon: "pi pi-eye",
                              iconPos: "left",
                              onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.clickDoanhThu()))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_DataTable, {
                          value: $setup.listHoaDon,
                          showGridlines: true,
                          paginator: true,
                          stripedRows: "",
                          rows: 10,
                          rowsPerPageOptions: [10,25,50],
                          rowHover: true,
                          dataKey: "id",
                          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                          currentPageReportTemplate: "Có tổng số {totalRecords} lượt mua",
                          columnResizeMode: "fit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              header: "Stt",
                              headerStyle: "width:3rem"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "giaBan",
                              header: "Giá bán",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "giamGia",
                              header: "Giảm giá (%)",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "giaThucThu",
                              header: "Giá thực thu",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "soTienDaThu",
                              header: "Số tiền đã thu",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.soTienDaThu)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "soTienNo",
                              header: "Số tiền nợ",
                              style: {"font-weight":"bold","color":"red"},
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatCurrency(data.soTienNo)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "thoiGianThuTien",
                              dataType: "date",
                              header: "Thời gian tạo",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianThuTien)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "nguoiThucHien",
                              header: "Người tạo",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "thoiGianCapNhat",
                              dataType: "date",
                              header: "Thời gian cập nhật",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "nguoiCapNhat",
                              header: "Người cập nhật",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, { header: "Chi tiết" }, {
                              body: _withCtx(({ data }) => [
                                _createVNode(_component_Button, {
                                  style: {"width":"100px"},
                                  class: "btn-spa-add",
                                  type: "button",
                                  label: "Xem",
                                  icon: "pi pi-eye",
                                  onClick: ($event: any) => ($setup.clickShowChiTietMore(data.id, data.thoiGianThuTien))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, { header: "Chỉnh sửa" }, {
                              body: _withCtx(({ data }) => [
                                _createVNode(_component_Button, {
                                  style: {"width":"150px"},
                                  class: "btn-spa-pause",
                                  type: "button",
                                  label: "Cập nhật",
                                  icon: "pi pi-sync",
                                  onClick: ($event: any) => ($setup.clickUpdateHoaDon(data.id))
                                }, null, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_82, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showDoanhThu,
                    "onUpdate:visible": _cache[30] || (_cache[30] = ($event: any) => (($setup.showDoanhThu) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '70vw'},
                    breakpoints: { '1500px': '50vw', '1150px': '70vw', '800px': '80vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Chi tiết doanh thu" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _hoisted_85,
                              _createVNode(_component_InputNumber, {
                                id: "tongGiaBan",
                                type: "text",
                                modelValue: $setup.doanhThu.tongGiaBan,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.doanhThu.tongGiaBan) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_86, [
                              _hoisted_87,
                              _createVNode(_component_InputNumber, {
                                id: "tongGiaNhap",
                                type: "text",
                                modelValue: $setup.doanhThu.tongGiaNhap,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (($setup.doanhThu.tongGiaNhap) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_88, [
                              _hoisted_89,
                              _createVNode(_component_InputNumber, {
                                id: "tongLoiNhuan",
                                type: "text",
                                modelValue: $setup.doanhThu.tongLoiNhuan,
                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.doanhThu.tongLoiNhuan) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _hoisted_91,
                              _createVNode(_component_InputNumber, {
                                id: "tongTienNo",
                                type: "text",
                                modelValue: $setup.doanhThu.tongTienNo,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.doanhThu.tongTienNo) = $event)),
                                inputId: "integeronly",
                                inputStyle: "color: red; font-weight: bold",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showHoaDonDetail,
                    "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => (($setup.showHoaDonDetail) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '90vw'},
                    breakpoints: { '1500px': '90vw', '1150px': '95vw', '800px': '95vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Lịch sử mua hàng" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createVNode(_component_DataTable, {
                                value: $setup.listHoaDonShow,
                                showGridlines: true,
                                paginator: true,
                                stripedRows: "",
                                rows: 10,
                                rowsPerPageOptions: [10,25,50],
                                rowHover: true,
                                dataKey: "id",
                                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                currentPageReportTemplate: "Có tổng số {totalRecords} lượt mua",
                                columnResizeMode: "fit"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giaBan",
                                    header: "Giá bán",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giamGia",
                                    header: "Giảm giá (%)",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giaThucThu",
                                    header: "Giá thực thu",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soTienDaThu",
                                    header: "Số tiền đã thu",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.soTienDaThu)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soTienNo",
                                    header: "Số tiền nợ",
                                    style: {"font-weight":"bold","color":"red"},
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.soTienNo)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "thoiGianThuTien",
                                    dataType: "date",
                                    header: "Thời gian tạo",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianThuTien)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "nguoiThucHien",
                                    header: "Người tạo",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "thoiGianCapNhat",
                                    dataType: "date",
                                    header: "Thời gian cập nhật",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatDateTime(data.thoiGianCapNhat)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "nguoiCapNhat",
                                    header: "Người cập nhật",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, { header: "Chi tiết" }, {
                                    body: _withCtx(({ data }) => [
                                      _createVNode(_component_Button, {
                                        style: {"width":"150px"},
                                        class: "btn-spa-pause",
                                        type: "button",
                                        label: "Xem",
                                        icon: "pi pi-eye",
                                        onClick: ($event: any) => ($setup.clickShowChiTiet(data.id, data.thoiGianThuTien))
                                      }, null, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ]),
                _createElementVNode("div", _hoisted_95, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showThanhPhanDetailMore,
                    "onUpdate:visible": _cache[32] || (_cache[32] = ($event: any) => (($setup.showThanhPhanDetailMore) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '90vw'},
                    breakpoints: { '1500px': '90vw', '1150px': '95vw', '800px': '95vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: $setup.ngayMuaHang }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, [
                              _createVNode(_component_DataTable, {
                                value: $setup.listThanhPhanDetailMore,
                                showGridlines: true,
                                paginator: true,
                                stripedRows: "",
                                rows: 10,
                                rowsPerPageOptions: [10,25,50],
                                rowHover: true,
                                dataKey: "id",
                                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                currentPageReportTemplate: "Có tổng số {totalRecords} sản phẩm đã mua",
                                columnResizeMode: "fit"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tenThanhPhan",
                                    header: "Tên sản phẩm",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "loaiThanhPhan",
                                    header: "Loại",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giaBan",
                                    header: "Giá bán",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giamGia",
                                    header: "Giảm giá (%)",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soLuong",
                                    header: "Số lượng",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giaThucThu",
                                    header: "Giá thực thu",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongTien",
                                    header: "Tổng tiền",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.tongTien)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["header"])
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showThanhPhanDetail,
                    "onUpdate:visible": _cache[33] || (_cache[33] = ($event: any) => (($setup.showThanhPhanDetail) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '90vw'},
                    breakpoints: { '1500px': '90vw', '1150px': '95vw', '800px': '95vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: $setup.ngayMuaHang }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_component_DataTable, {
                                value: $setup.listThanhPhanDetail,
                                showGridlines: true,
                                paginator: true,
                                stripedRows: "",
                                rows: 10,
                                rowsPerPageOptions: [10,25,50],
                                rowHover: true,
                                dataKey: "id",
                                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                                currentPageReportTemplate: "Có tổng số {totalRecords} sản phẩm đã mua",
                                columnResizeMode: "fit"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Column, {
                                    header: "Stt",
                                    headerStyle: "width:3rem"
                                  }, {
                                    body: _withCtx((slotProps) => [
                                      _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tenThanhPhan",
                                    header: "Tên sản phẩm",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "loaiThanhPhan",
                                    header: "Loại",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giaBan",
                                    header: "Giá bán",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaBan)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giamGia",
                                    header: "Giảm giá (%)",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "soLuong",
                                    header: "Số lượng",
                                    sortable: ""
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "giaThucThu",
                                    header: "Giá thực thu",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.giaThucThu)), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_Column, {
                                    field: "tongTien",
                                    header: "Tổng tiền",
                                    sortable: ""
                                  }, {
                                    body: _withCtx(({data}) => [
                                      _createTextVNode(_toDisplayString($setup.formatCurrency(data.tongTien)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["header"])
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showUpdateHoaDon,
                    "onUpdate:visible": _cache[40] || (_cache[40] = ($event: any) => (($setup.showUpdateHoaDon) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '90vw'},
                    breakpoints: { '1500px': '90vw', '1150px': '95vw', '800px': '95vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Cập nhật hóa đơn" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, [
                              _hoisted_104,
                              _createVNode(_component_InputNumber, {
                                id: "giaBan2",
                                type: "text",
                                modelValue: $setup.hoaDonUpdate.giaBan,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (($setup.hoaDonUpdate.giaBan) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_105, [
                              _hoisted_106,
                              _createVNode(_component_InputNumber, {
                                id: "giamgia2",
                                type: "text",
                                modelValue: $setup.hoaDonUpdate.giamGia,
                                "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (($setup.hoaDonUpdate.giamGia) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_107, [
                              _hoisted_108,
                              _createVNode(_component_InputNumber, {
                                id: "giaThucThu2",
                                type: "text",
                                modelValue: $setup.hoaDonUpdate.giaThucThu,
                                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (($setup.hoaDonUpdate.giaThucThu) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_109, [
                              _hoisted_110,
                              _createVNode(_component_InputNumber, {
                                id: "soTienDaThu",
                                type: "text",
                                modelValue: $setup.hoaDonUpdate.soTienDaThu,
                                "onUpdate:modelValue": [
                                  _cache[37] || (_cache[37] = ($event: any) => (($setup.hoaDonUpdate.soTienDaThu) = $event)),
                                  $setup.clickTraTruocUpdate
                                ],
                                inputId: "integeronly"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_111, [
                              _hoisted_112,
                              _createVNode(_component_InputNumber, {
                                id: "soTienNo",
                                type: "text",
                                modelValue: $setup.hoaDonUpdate.soTienNo,
                                "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (($setup.hoaDonUpdate.soTienNo) = $event)),
                                inputId: "integeronly"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createVNode(_component_Button, {
                            label: "Cập nhật",
                            icon: "pi pi-money-bill",
                            iconPos: "left",
                            class: "btn-spa-buy",
                            onClick: _cache[39] || (_cache[39] = ($event: any) => ($setup.updateHoaDon()))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_AccordionTab, {
              header: "THỰC HIỆN LIỆU TRÌNH",
              style: {"font-weight":"bold"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Panel, { header: "" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _hoisted_115,
                        _createVNode(_component_Calendar, {
                          id: "date",
                          modelValue: $setup.dateLT,
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (($setup.dateLT) = $event)),
                          selectionMode: "range",
                          dateFormat: "dd/mm/yy",
                          showButtonBar: true,
                          showIcon: true,
                          manualInput: false,
                          monthNavigator: true,
                          yearNavigator: true,
                          yearRange: "2000:2100",
                          onDateSelect: _cache[42] || (_cache[42] = ($event: any) => ($setup.selectCalendarLT())),
                          onClearClick: _cache[43] || (_cache[43] = ($event: any) => ($setup.clearCalendar()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_116, [
                        _createVNode(_component_DataTable, {
                          value: $setup.listLichSuLieuTrinh,
                          showGridlines: true,
                          paginator: true,
                          stripedRows: "",
                          rows: 10,
                          rowsPerPageOptions: [10,25,50],
                          rowHover: true,
                          filters: $setup.filters,
                          "onUpdate:filters": _cache[44] || (_cache[44] = ($event: any) => (($setup.filters) = $event)),
                          globalFilterFields: ['tenLieuTrinh'],
                          dataKey: "id",
                          paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                          currentPageReportTemplate: "Có tổng số {totalRecords} liệu trình",
                          columnResizeMode: "fit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Column, {
                              header: "Stt",
                              headerStyle: "width:3rem"
                            }, {
                              body: _withCtx((slotProps) => [
                                _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "tenLieuTrinh",
                              header: "Liệu trình",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "soLanThucHien",
                              header: "Đã thực hiện(lần)",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "tongSoLanThucHien",
                              header: "Tổng số(lần)",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "nguoiThucHien",
                              header: "Người thực hiện gần nhất",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "ngayThucHien",
                              header: "Ngày thực hiện gần nhất",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayThucHien)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "ngayMua",
                              header: "Ngày mua",
                              style: {"font-weight":"bold","color":"red"},
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                _createTextVNode(_toDisplayString($setup.formatDateTime(data.ngayMua)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Column, {
                              field: "khoangCachDieuTri",
                              header: "Khoảng cách giữa các lần(ngày)",
                              sortable: ""
                            }),
                            _createVNode(_component_Column, {
                              field: "",
                              dataType: "date",
                              header: "Tùy chọn",
                              sortable: ""
                            }, {
                              body: _withCtx(({data}) => [
                                (data.tongSoLanThucHien > data.soLanThucHien)
                                  ? (_openBlock(), _createBlock(_component_Button, {
                                      key: 0,
                                      style: {"max-width":"200px"},
                                      label: "Thực hiện",
                                      class: "btn-spa-update",
                                      icon: "pi pi-save",
                                      iconPos: "left",
                                      onClick: ($event: any) => ($setup.clickThucHienLT(data.idMuaLieuTrinh))
                                    }, null, 8, ["onClick"]))
                                  : (_openBlock(), _createBlock(_component_Button, {
                                      key: 1,
                                      style: {"max-width":"200px"},
                                      label: "Đã hoàn thành",
                                      class: "btn-spa-pause",
                                      icon: "pi pi-shield",
                                      iconPos: "left"
                                    }))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["value", "filters"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_117, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showDoanhThu,
                    "onUpdate:visible": _cache[49] || (_cache[49] = ($event: any) => (($setup.showDoanhThu) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '70vw'},
                    breakpoints: { '1500px': '50vw', '1150px': '70vw', '800px': '80vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Chi tiết doanh thu" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_118, [
                            _createElementVNode("div", _hoisted_119, [
                              _hoisted_120,
                              _createVNode(_component_InputNumber, {
                                id: "tongGiaBan",
                                type: "text",
                                modelValue: $setup.doanhThu.tongGiaBan,
                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => (($setup.doanhThu.tongGiaBan) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_121, [
                              _hoisted_122,
                              _createVNode(_component_InputNumber, {
                                id: "tongGiaNhap",
                                type: "text",
                                modelValue: $setup.doanhThu.tongGiaNhap,
                                "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (($setup.doanhThu.tongGiaNhap) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_123, [
                              _hoisted_124,
                              _createVNode(_component_InputNumber, {
                                id: "tongLoiNhuan",
                                type: "text",
                                modelValue: $setup.doanhThu.tongLoiNhuan,
                                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (($setup.doanhThu.tongLoiNhuan) = $event)),
                                inputId: "integeronly",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_125, [
                              _hoisted_126,
                              _createVNode(_component_InputNumber, {
                                id: "tongTienNo",
                                type: "text",
                                modelValue: $setup.doanhThu.tongTienNo,
                                "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (($setup.doanhThu.tongTienNo) = $event)),
                                inputId: "integeronly",
                                inputStyle: "color: red; font-weight: bold",
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ]),
                _createElementVNode("div", _hoisted_127, [
                  _createVNode(_component_Dialog, {
                    visible: $setup.showThucHienLT,
                    "onUpdate:visible": _cache[54] || (_cache[54] = ($event: any) => (($setup.showThucHienLT) = $event)),
                    modal: "",
                    blockScroll: "",
                    style: { width: '70vw'},
                    breakpoints: { '1500px': '50vw', '1150px': '70vw', '800px': '80vw' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Panel, { header: "Thực hiện liệu trình" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_128, [
                            _createElementVNode("div", _hoisted_129, [
                              _hoisted_130,
                              _createVNode(_component_InputText, {
                                id: "tenLieuTrinh",
                                type: "text",
                                modelValue: $setup.thucHienLieuTrinhCreate.tenLieuTrinh,
                                "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => (($setup.thucHienLieuTrinhCreate.tenLieuTrinh) = $event)),
                                readonly: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_131, [
                              _hoisted_132,
                              _createVNode(_component_InputNumber, {
                                id: "soLuong",
                                type: "text",
                                modelValue: $setup.thucHienLieuTrinhCreate.soLuong,
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (($setup.thucHienLieuTrinhCreate.soLuong) = $event)),
                                inputId: "integeronly"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_133, [
                              _hoisted_134,
                              _createVNode(_component_Calendar, {
                                id: "date",
                                modelValue: $setup.dateThucHien,
                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => (($setup.dateThucHien) = $event)),
                                selectionMode: "single",
                                dateFormat: "dd/mm/yy",
                                showButtonBar: true,
                                showIcon: true,
                                manualInput: false,
                                monthNavigator: true,
                                yearNavigator: true,
                                yearRange: "2000:2100"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          ($setup.validThucHienLT)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                label: "Thực hiện",
                                icon: "pi pi-check-circle",
                                iconPos: "left",
                                class: "btn-spa-update",
                                onClick: _cache[53] || (_cache[53] = ($event: any) => ($setup.createThucHienLieuTrinh()))
                              }))
                            : (_openBlock(), _createBlock(_component_Button, {
                                key: 1,
                                label: "Thực hiện",
                                icon: "pi pi-check-circle",
                                iconPos: "left",
                                class: "btn-spa-pause",
                                disabled: "disabled"
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}